import { AxiosResponse } from 'axios';
import { Result } from '@/main/models/common/resultResponse';
import { ControlRequest } from '@/main/models/request/controlRequest';
import {
  ControlRegistrationDataResponse,
  ControlResponse
} from '@/main/models/response/controlResponse';

export abstract class IControlApi {
  abstract getByGroupWithPermissions(
    request: ControlRequest
  ): Promise<AxiosResponse<Result<ControlRegistrationDataResponse>>>;

  abstract getControlsByScreenApi(
    guidScreen: string
  ): Promise<AxiosResponse<Result<ControlResponse[]>>>;
}
